import { createContext, useCallback, useContext, useEffect, useMemo, useState, type ReactNode } from 'react'
import { platformApi } from './api'

export interface PlatformUser { id: string; email?: string; name?: string; full_name?: string; role: 'superadmin' | 'support' }

interface PlatformAuthValue {
  user: PlatformUser | null
  loading: boolean
  beginLogin: (email: string, password: string) => Promise<any>
  verify: (challenge: string, code?: string, recoveryCode?: string) => Promise<any>
  logout: () => Promise<void>
}

const Context = createContext<PlatformAuthValue | null>(null)

export function PlatformAuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<PlatformUser | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true
    platformApi.restore().then((result) => { if (active && result) setUser(result) }).finally(() => { if (active) setLoading(false) })
    return () => { active = false }
  }, [])

  const beginLogin = useCallback((email: string, password: string) => platformApi.login(email, password), [])
  const verify = useCallback(async (challenge: string, code?: string, recoveryCode?: string) => {
    const result = await platformApi.verifyMfa(challenge, code, recoveryCode)
    setUser(await platformApi.me())
    return result
  }, [])
  const logout = useCallback(async () => { await platformApi.logout(); sessionStorage.removeItem('inogym-deployment-status'); setUser(null) }, [])
  const value = useMemo(() => ({ user, loading, beginLogin, verify, logout }), [user, loading, beginLogin, verify, logout])
  return <Context.Provider value={value}>{children}</Context.Provider>
}

export function usePlatformAuth() {
  const value = useContext(Context)
  if (!value) throw new Error('PlatformAuthProvider nedostaje')
  return value
}
